/**
 * Environment Configuration
 * Validates and exports environment variables
 */

const requiredEnvVars = ['REACT_APP_BASE_URL'];

/**
 * Validates that all required environment variables are set
 */
const validateEnv = () => {
  const missing = requiredEnvVars.filter(
    varName => !process.env[varName]
  );
  
  if (missing.length > 0) {
    const errorMessage = `Missing required environment variables: ${missing.join(', ')}`;
    console.error(errorMessage);
    
    if (process.env.NODE_ENV === 'production') {
      throw new Error(errorMessage);
    }
  }
};

// Validate on module load
validateEnv();

/**
 * Environment configuration object
 */
export const ENV = {
  // API Configuration
  API_URL: process.env.REACT_APP_BASE_URL || '',
  /** same-origin path proxied by nginx, which adds the gateway key; falls back to API_URL + admin/ */
  ADMIN_API_URL: process.env.REACT_APP_ADMIN_API_URL || '',
  URL_KEY_STRING: process.env.REACT_APP_URL_KEY_STRING || '',
  
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_TEST: process.env.NODE_ENV === 'test',
  
  // Optional: Error Tracking
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || '',
  
  // Optional: Analytics
  GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID || '',
};

export default ENV;

